import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const emphasisInHeadingFn = /* @__PURE__ */ createRecipe('emphasis-in-heading', {}, [])

const emphasisInHeadingVariantMap = {}

const emphasisInHeadingVariantKeys = Object.keys(emphasisInHeadingVariantMap)

export const emphasisInHeading = /* @__PURE__ */ Object.assign(memo(emphasisInHeadingFn.recipeFn), {
  __recipe__: true,
  __name__: 'emphasisInHeading',
  __getCompoundVariantCss__: emphasisInHeadingFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: emphasisInHeadingVariantKeys,
  variantMap: emphasisInHeadingVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, emphasisInHeadingVariantKeys)
  },
  getVariantProps: emphasisInHeadingFn.getVariantProps,
})